import React, { useEffect, useState } from 'react'
import { Flex } from '@rebass/grid'
import Image from '../../atoms/Image'
import Button from '../../atoms/Button'
import Modal from '../../molecules/Modal'
import { useAuth } from '../../../contexts/auth'

const LOCAL_STORAGE_KEY_WHATS_NEW_LAST_OPENED = 'WHATS_NEW_LAST_OPENED'
const WHATS_NEW_UPDATED_TIME = new Date('2026-05-19 02:47:00 +0800').valueOf()

const WhatsNewHandler = () => {
  const [modalOpened, setModalOpened] = useState()
  const { auth } = useAuth()

  useEffect(() => {
    if (auth.user) {
      const whatsNewKey = `${auth.user.username}_${LOCAL_STORAGE_KEY_WHATS_NEW_LAST_OPENED}`
      const lastOpened = localStorage.getItem(whatsNewKey)
      if (!lastOpened || Number(lastOpened) < WHATS_NEW_UPDATED_TIME) {
        setModalOpened(true)
        localStorage.setItem(whatsNewKey, new Date().valueOf())
      }
    }
  }, [auth.user])

  return (
    <Modal
      isOpen={modalOpened}
      onClose={() => setModalOpened(false)}
      showCloseBtn
    >
      <Image
        src="/whats-new.jpeg"
        width="100%"
        height="100%"
        borderRadius="0.5rem"
        style={{ maxHeight: '78vh', objectFit: 'contain' }}
      />
      <Flex justifyContent="flex-end" width={1} mt="0.5rem">
        <Button to="/" onClick={() => setModalOpened(false)}>
          試下 🚀
        </Button>
      </Flex>
    </Modal>
  )
}

export default WhatsNewHandler
